import {useState, useEffect} from "react";
import {getAocChallenges, deleteAcoChallenge, getRandomAoc} from "../services/api";

export function ListAocChallenges() {    
    const [challenges, setChallenges] = useState([])
    const [selectedChallenge, setSelectedChallenge] = useState(null)
    const [randomId, setRandomId] = useState(0)
    const [randomChoice, setRandomChoice] = useState(null)
    
    
    useEffect(() => {
        getAocChallenges()
            .then(apiChallenges => {
                setChallenges(apiChallenges)
                //Get selected challenge and set it it it exists.
                const selected = apiChallenges.filter(c => c.selected).at(0)
                if (selected) {
                    setSelectedChallenge(selected)
                }
                
            })
            .catch(ex => {
                console.log("Error getting challenges")
            })
        
    }, [])
    
    let complete = async (id) => {
        try {
            await deleteAcoChallenge(id)
            let newChallenges = challenges.filter(c => c.aocChallengeId != id)
            setSelectedChallenge(null)
            setChallenges(newChallenges)
        } catch (ex) {
            console.log("Error completing aoc challenge: ", ex)
        }

    }
    
    let getRandom = async () => {
        try {
            let result = await getRandomAoc()
            setRandomId(result.aocChallengeId)
            setRandomChoice(result)
            setSelectedChallenge(result)

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // Optional: for smooth scrolling animation
            })
        } catch(ex) {
            console.log("Error getting random AOC")
        }
    }
    
    return (
        <>
            {selectedChallenge && <div className="alert alert-info">
                Current Challenge: Year: {selectedChallenge.year}, Day: {selectedChallenge.day}
            </div> }
            
            
            {challenges &&
                <>
                    <button type="button" className="btn btn-primary" onClick={getRandom}>
                        Choose Random
                    </button>
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Year</th>
                            <th>Day</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {challenges.map(c => {
                            return <tr key={c.aocChallengeId}
                                       className={randomId == c.aocChalengeId ? "bg-success" : ""}>
                                <td>{c.year}</td>
                                <td>{c.day}</td>
                                <td>
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => complete(c.aocChallengeId)}>Complete
                                    </button>
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                </>
            }</>
    )
}